<template>
  <div ref='root' class='root plugin'>
    <div class='menu-container'>
      <!-- <amplify-authenticator
        :authConfig='authConfig'
      /> -->
      <!-- <div class="menu" v-bind:class="{ lab: isLabMode }" ref="StepMenuRoot"></div> -->
      <div class="menu" v-bind:class="labMenuClass" ref="StepMenuRoot">
        <lang-toggle class='lang-toggle-panel' variant='light' />
        <div class='logo' v-html='svg.logo'></div>
        <div class='user'>{{ userLabel ? $t(userLabel) : '' }}</div>
        <PluginStep1Menu
          v-show="step === 0"
          :properties="properties"
          :materials="materials"
          :material_assortments="material_assortments"
          :paintOptions="paintOptions"
          :toolPathExists="toolPathExists"
          :isLabAvailable="isLabAvailable"
          :isLabMode="isLabMode"
          :toggleLabMode="toggleLabMode"
          :useNewApiVersion="useNewApiVersion"
          @changeMachine="changeMachine"
          @changeMillSize="changeMillSize"
          @changeApiVersion="changeApiVersion"
          @all="filletAll"
          @undo="filletUndo"
          @redo="filletRedo"
          @reset="filletReset"
          @selectFilletType="selectFilletType"
          @next="next_step1"
          @skip="skip"
          @nonesting="nonesting"
          @cancel="cancel"
          @confirm="showConfirmStep1"
        />
        <PluginStep2Menu
          v-show="step === 1"
          :properties="properties"
          :isLabMode="isLabMode"
          :useNewApiVersion="useNewApiVersion"
          @nest="nestByApi"
          @addPart="partAdd"
          @removePart="partRemove"
          @add="nestingAdd"
          @remove="nestingRemove"
          @undo="nestingUndo"
          @redo="nestingRedo"
          @reset="nestingReset"
          @next="next_step2"
          @prev="prev"
          @changeApiVersion="changeApiVersion"
        />
        <PluginStep3Menu
          v-show="step === 2"
          :properties="properties"
          :materials="materials"
          :material_assortments="material_assortments"
          :error="error"
          :totalCost="cost.total_cost_tax"
          :deliveryDate="deliveryDate"
          :costItems="costItems"
          :isLoading="isLoading"
          :isLabMode="isLabMode"
          @quotation="showQuotation"
          @order="onOrder"
          @savemypage="onSaveMypage"
          @tostep1="toStep1"
          @tostep2="prev"
          @tomypage="toMypage"
          @downloadsbp="downloadSBP"
          @toNextSbpPreview="toNextSbpPreview"
        />
      </div>
    </div>
    <div class='container'>
      <PluginStepper :step="step" />
      <Fillet
        ref="Fillet"
        v-show='step === 0'
      />
      <Nesting
        ref='Nesting'
        v-show='step === 1'
      />
      <div id='viewer'
        v-show='step === 2'
      >
        <canvas ref='canvas'></canvas>
      </div>
      <div class='shopbot' v-if='step === 2 && isSbp && sbp !== null'>
        <Timeline
          ref="Timeline"
          :cnc="cnc"
          @change="$options.controller.setTimeline($event)"
          @binvisible="$options.controller.setBinVisibled($event)"
          @toolpathvisible="$options.controller.setToolpathVisibled($event)"
          @cncvisible="($e) => {
            this.$options.controller.setCNCVisibled($e);
            this.cnc = $e;
          }"
          @tabvisible="$options.controller.setTabVisibled($event)"
          @bisuvisible="$options.controller.setBisuVisibled($event)"
          @labelinfovisible="$options.controller.setLabelinfoVisibled($event)"
        />
      </div>
      <LoadingIndicator
        v-show='isLoading'
        :isRequestingCAM="isRequestingCAM"
        :cancellable="isRequestingNesting"
        @cancel="onCancel"
      />
      <AlertPopup ref='AlertPopup' />
      <QuotationPopup ref='QuotationPopup' :projectId="project.id" :cost="cost" :costItems="costItems" />
      <GuidelinePopup
        ref='GuidelinePopup'
        @complete='completeGuidelinePopup'
      />
      <ConfirmPopup
        ref='ConfirmPopup'
        @order='onConfirmOk'
      />
    </div>
  </div>
</template>

<script>

import svgLogo from '@/assets/images/e.svg';
import PluginBase from './PluginBase.vue';
import LangToggle from '@/components/viewer/LangToggle.vue';

export default {
  components: { LangToggle },
  name: 'Plugin',
  extends: PluginBase,

  data () {
    return {
      svg: {
        logo: svgLogo
      },
      pendingAction: null
    };
  },

  mounted () {
    this.setupPopups([
      this.$refs.AlertPopup,
      this.$refs.QuotationPopup,
      this.$refs.ConfirmPopup,
      this.$refs.GuidelinePopup
    ]);
  },

  computed: {
    labMenuClass() {
      if (this.isLabMode) {
        if (this.properties.isBeginner && !this.properties.isExpert) {
          return 'lab-beginner';
        } else if (!this.properties.isBeginner && this.properties.isExpert) {
          return 'lab-expert';
        } else if (!this.properties.isBeginner && !this.properties.isExpert) {
          return 'lab';
        }
      }
      return '';
    },
    userLabel() {
      if (this.isLabMode) {
        if (this.properties.isBeginner && !this.properties.isExpert) {
          return '初心者用';
        } else if (!this.properties.isBeginner && this.properties.isExpert) {
          return '上級者用';
        } else if (!this.properties.isBeginner && !this.properties.isExpert) {
          return 'オーナー用';
        }
      }
      return '';
    }
  },

  watch: {
    step: function(value) {
      if(value === 1) {
        if (this.getCookie('neverShowGuidelinePopup') == "true") {
          return;
        } else {
          this.$refs.GuidelinePopup.show();
        }
      }
    }
  },

  methods: {
    showConfirmStep1 (action) {
      if (this.isProjectAfterRelease20241208() && !this.isLabMode) {
        this.pendingAction = action;
        this.$refs.ConfirmPopup.show();
        
      } else {
        this.executePendingAction(action);
      }
    },

    onConfirmOk () {
      this.$refs.ConfirmPopup.hide();
      if (this.pendingAction) {
        this.executePendingAction(this.pendingAction);
        this.pendingAction = null;
      }
    },

    executePendingAction (action) {
      if (action === 'next') {
        this.next_step1();
      } else if (action === 'skip') {
        this.skip();
      }
    },

    completeGuidelinePopup (neverShowAgain) {
      if(neverShowAgain){
        document.cookie = 'neverShowGuidelinePopup=true';
      }
      this.$refs.GuidelinePopup.hide();
    },

    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2)
      return parts.pop().split(';').shift();
    }
  }
};

</script>

<style scoped>
.lang-toggle-panel {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 50;
  padding: 4px 8px;
  border-radius: 14px;
  background-color: rgba(0, 0, 0, 0.06);
}
</style>



// WEBPACK FOOTER //
// src/pages/Plugin.vue